/**
 * LO QUE EL CLIENTE APUNTA DE SU ENTRENO, REVISADO ANTES DE MANDARLO (14-10, RUT-05 y RUT-11).
 *
 * El servidor ya valida (`backend/models/workout_log.py`: nota de 2.000 caracteres como
 * mucho, repeticiones y kilos entre 0 y 1.000), pero contestaba un 422 y la pantalla decía
 * «Inténtalo en un momento»: reintentar no servía nunca y el cliente creía que la app
 * fallaba. Y una fila con repeticiones y kilos pero sin el nombre del ejercicio se tiraba
 * sin avisar con un «Entreno guardado».
 *
 * Aquí se dice QUÉ corregir. Los topes son los del servidor: si cambian allí, cambian aquí.
 * No pinta nada: devuelve `{ ok, error }` o `{ ok, pesos }` y la pantalla lo enseña.
 */

export const NOTA_MAXIMO = 2000;
export const REPS_MAXIMO = 1000;
export const KILOS_MAXIMO = 1000;

const vacio = (v) => v === '' || v === null || v === undefined;
const numero = (v) => Number(String(v).replace(',', '.'));

/**
 * @param {{nota?: string, pesos?: Array<{ejercicio?: string, reps?: *, peso_kg?: *}>}} entreno
 * @returns {{ok: true, pesos: Array}|{ok: false, error: string}}
 */
export function revisarEntreno({ nota = '', pesos = [] } = {}) {
    if ((nota || '').trim().length > NOTA_MAXIMO) {
        return { ok: false, error: `La nota es demasiado larga: como mucho ${NOTA_MAXIMO.toLocaleString('es-ES')} caracteres.` };
    }
    const limpios = [];
    for (const f of pesos || []) {
        const ejercicio = (f.ejercicio || '').trim();
        // La fila entera en blanco es la que la pantalla deja preparada: no dice nada.
        if (!ejercicio && vacio(f.reps) && vacio(f.peso_kg)) continue;
        if (!ejercicio) {
            return { ok: false, error: 'Hay una fila de pesos sin el nombre del ejercicio. Escríbelo o quita la fila.' };
        }
        const reps = vacio(f.reps) ? null : numero(f.reps);
        const kilos = vacio(f.peso_kg) ? null : numero(f.peso_kg);
        if (reps !== null && !(Number.isInteger(reps) && reps >= 0 && reps <= REPS_MAXIMO)) {
            return { ok: false, error: `Revisa las repeticiones de «${ejercicio}»: un número entero entre 0 y ${REPS_MAXIMO.toLocaleString('es-ES')}.` };
        }
        if (kilos !== null && !(Number.isFinite(kilos) && kilos >= 0 && kilos <= KILOS_MAXIMO)) {
            return { ok: false, error: `Revisa los kilos de «${ejercicio}»: entre 0 y ${KILOS_MAXIMO.toLocaleString('es-ES')}.` };
        }
        limpios.push({ ejercicio, reps, peso_kg: kilos });
    }
    return { ok: true, pesos: limpios };
}
